import { useTranslation } from "react-i18next";

interface TemplatesStatsProps {
    total: number;
    v2: number;
    v1: number;
    responsive: number;
}

/**
 * Inline stat strip shown under the Templates page title. Mirrors the Screens stats strip so the
 * two list pages read as one family. All counts are derived from the loaded templates.
 */
export function TemplatesStats({ total, v2, v1, responsive }: TemplatesStatsProps) {
    const { t } = useTranslation();

    const stats: { label: string; value: number }[] = [
        { label: t("templates.stats.total"), value: total },
        { label: t("templates.stats.v2"), value: v2 },
        { label: t("templates.stats.v1"), value: v1 },
        { label: t("templates.stats.responsive"), value: responsive },
    ];

    return (
        <div className="grid grid-cols-2 divide-y divide-border overflow-hidden rounded-lg border bg-card sm:grid-cols-4 sm:divide-x sm:divide-y-0">
            {stats.map((stat) => (
                <div key={stat.label} className="flex flex-col gap-1 px-4 py-2.5">
                    <span className="text-[10.5px] font-medium uppercase tracking-wide text-muted-foreground">
                        {stat.label}
                    </span>
                    <span className="font-heading text-xl font-semibold leading-none tracking-tight tabular-nums">
                        {stat.value}
                    </span>
                </div>
            ))}
        </div>
    );
}
